<script lang="ts">
  import { resolve } from '$app/paths'

  import { getTitle } from '$lib/components/title'
  import Container from '$lib/site/Container.svelte'
  import Signup from '$lib/site/Signup.svelte'
  import { variables } from '$lib/variables.js'

  const { data } = $props()
</script>

<svelte:head>
  <title>{getTitle(data.title, `The ${variables.appName} Blog`)}</title>
  <meta name="description" content={data.excerpt} />
  <meta name="twitter:title" content={data.title} />
  <meta name="twitter:description" content={data.excerpt} />
  <meta property="og:type" content="article" />
  <meta property="og:title" content={data.title} />
  <meta property="og:description" content={data.excerpt} />
  <meta property="og:url" content={`https://turbomaps.io/blog/${data.filename}`} />
</svelte:head>

<Container nav padding>
  <article class="post">
    <div class="content prose full-width">
      <div class="inner">
        <nav>
          <a href={resolve('/blog')}>&larr; All Posts</a>
        </nav>
        <h1>{data.title}</h1>
        <div class="meta">
          <h4><time>{data.date}</time> &middot; Written by <strong>{data.author}</strong></h4>
        </div>
        <!-- eslint-disable-next-line svelte/no-at-html-tags -->
        {@html data.content}
      </div>
    </div>
  </article>
</Container>
<div class="signup-bg">
  <Container footer>
    <div class="signup">
      <h2>The Turbomaps Blog</h2>
      <Signup />
    </div>
  </Container>
</div>

<style>
  nav {
    margin: 1rem 0 0;
  }
  nav a {
    font-size: 0.8rem;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  nav a:visited {
    color: var(--surface-text-interactive);
  }
  h1 {
    font-size: 2rem;
    line-height: 1.3;
    margin: 0.25em 0;
    letter-spacing: -0.5px;
    font-family: var(--font-serif);
  }
  @media (min-width: 500px) {
    h1 {
      font-size: 2.5rem;
    }
  }
  .meta h4 {
    font-size: 0.8rem;
    margin: 0.25em 0 2em;
    color: var(--surface-text-faint);
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .post {
    margin: 0 auto;
  }
  .content {
    border-radius: 0.75rem;
    overflow: hidden;
  }
  .inner {
    max-width: 600px;
    margin: 0 auto;
    padding: 0;
  }
  @media (min-width: 500px) {
    .content {
      border-radius: 1rem;
    }
    .inner {
      padding: 0 2rem;
    }
  }
  .signup-bg {
    background-color: var(--surface-bg);
    background-image:
      linear-gradient(rgba(250, 250, 249, 0.25), rgba(250, 250, 249, 1) 60%),
      url(/site/hero-light.avif);
    border-top: 1px solid var(--surface-border);
    background-size: 100%;

    @media (prefers-color-scheme: dark) {
      background-image:
        linear-gradient(rgb(57, 57, 57, 0.25), rgb(57, 57, 57, 1) 60%), url(/site/hero-dark.avif);
      border-color: #111;
    }
  }
  .signup {
    text-align: center;
    padding: 2rem 1rem 3rem;
  }
</style>
